import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-breadcrum',
    templateUrl: './breadcrum.component.html',
    styleUrls: ['./breadcrum.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BreadcrumsComponent {
  routeChild: any;
  routeParent: any;

}
